import { List, ListItem, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

interface ListItemSkeletonProps {
    totalItems: number;
}

export function ListItemSkeleton({
    totalItems = 1
}: ListItemSkeletonProps) {

    function renderListItems() {
        const items = [];
        for (let i = 0; i < totalItems; i++) {
            items.push(<Item key={i} />);
        }
        return items;
    }
    return <List key="Skeltonloader">
        {renderListItems()}
    </List>;
}

function Item() {
    return <ListItem>
        <ListItemText primary={<Skeleton animation="wave" />} />
        <ListItemSecondaryAction
            style={{
                border: "1px solid #cccccc",
                borderRadius: "1rem",
                padding: "0 0.5rem",
                fontSize: "1rem"
            }}
        >
            <Skeleton animation="wave" />
        </ListItemSecondaryAction>
    </ListItem>;
}